import { MutationTree } from "vuex";
import { Societe } from "@/shared/Groupe";
import { ConfigState } from "./types";

export const mutations: MutationTree<ConfigState> = {
  SET_SOCIETES(state, societes: Societe[]) {
    state.societes = societes;
    localStorage.societes = JSON.stringify(societes);
  },
  SET_GROUPES(state, groupes: []) {
    state.groupes = groupes;
  },
  SET_PROFILS(state, data: []) {
    state.profils = data;
  },
  SET_USERS(state, data: []) {
    state.utilisateurs = data;
  },
  SET_FECRESTAURANT_ID(state, fecRestaurantId: number | null) {
    state.fecRestaurantId = fecRestaurantId;
  },
  SET_SOCIETES_A_CREER(state, societesACreer: []) {
    state.societesACreer = societesACreer;
  },
};
